<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    {{ 'Menu Configuration'|translate }}
                </v-card-title>
                <v-layout row>
                    <v-flex xs5 style="padding:10px">
                        <v-card>
                            <v-card-title class="primary white--text text--title">
                                {{ 'Menu List'|translate }}
                            </v-card-title>
                            <v-card-text>
                                <v-layout row>
                                    <v-flex xs5>
                                        <v-text-field padding="0px" height="20px" :label="'New Folder Name'|translate"
                                                      v-model="newFolderName" v-on:keyup.enter="addFolder()" outlined
                                                      dense></v-text-field>
                                    </v-flex>
                                    <v-flex xs1>
                                        <v-btn v-if="newFolderName" icon class="primary" @click="addFolder()">
                                            <v-icon small>fa-plus</v-icon>
                                        </v-btn>
                                    </v-flex>
                                    <v-flex xs5>
                                        <v-text-field padding="0px" height="20px" :label="'New Link Name'|translate"
                                                      v-model="newLinkName" v-on:keyup.enter="addLink()" outlined
                                                      dense></v-text-field>
                                    </v-flex>
                                    <v-flex xs1>
                                        <v-btn v-if="newLinkName" icon class="primary" @click="addLink()">
                                            <v-icon small>fa-plus</v-icon>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                            <v-card-text>
                                <draggable v-model="menuList" group="people" @start="drag=true" @end="drag=false"
                                           class="menu_panel">
                                    <div v-for="element of menuList" class="draggable_card">
                                        <v-card
                                            v-if="element.children && element.text!='Custom Views' && element.text!='Default Views'"
                                            class="draggable_folder">
                                            <v-subheader style="text-indent:10px"><i class="fa fa-folder"
                                                                                     aria-hidden="true"></i> &nbsp;
                                                {{ element.text }}
                                                <v-spacer></v-spacer>
                                                <v-btn icon class="primary"
                                                       @click="editedFolder=element; dialogEditFolderName=true;">
                                                    <v-icon small>fa-edit</v-icon>
                                                </v-btn>
                                                <v-btn v-if="element.children.length==0" icon class="primary"
                                                       @click="removeFolder(element)">
                                                    <v-icon small>fa-trash</v-icon>
                                                </v-btn>
                                            </v-subheader>
                                            <draggable v-model="element.children" group="people" @start="drag=true"
                                                       @end="drag=false" class="draggable_space">
                                                <v-card v-for="child of element.children"
                                                        class="cv_in_folder align-center accent pa-1 pl-3">
                                                    <v-layout row>
                                                        <v-flex xs9>
                                                            <v-icon v-if="child.icon" small
                                                                    class="cv_icon align-center"> {{ child.icon }}
                                                            </v-icon>
                                                            {{ child.text }}
                                                        </v-flex>
                                                        <v-flex xs3>
                                                            <v-layout row wrap justify-end v-if="child.to">
                                                                <v-icon v-if="child.to.startsWith('/custom-view/')"
                                                                        class="cv_icon"
                                                                        :color="publishedCustomViewSet.has(child.to) ? 'primary' : 'error'">
                                                                    fa-chart-bar
                                                                </v-icon>
                                                                <v-btn small icon class="primary cv_edit_btn"
                                                                       @click="editedLink = child; linkDialog=true;">
                                                                    <v-icon small>fa-pen</v-icon>
                                                                </v-btn>
                                                                <v-btn small icon class="primary cv_edit_btn"
                                                                       @click="moveCustomViewToAvailable(child)">
                                                                    <v-icon small>fa-arrow-right</v-icon>
                                                                </v-btn>
                                                            </v-layout>
                                                            <v-layout row wrap justify-end
                                                                      v-if="child.href||child.href===''">
                                                                <v-icon class="cv_icon" color="primary"> fa-link
                                                                </v-icon>
                                                                <v-btn small icon class="primary cv_edit_btn"
                                                                       @click="editedLink = child; linkDialog=true;">
                                                                    <v-icon small>fa-pen</v-icon>
                                                                </v-btn>
                                                                <v-btn small icon class="primary cv_edit_btn"
                                                                       @click="removeItemCH(child,element)">
                                                                    <v-icon small>fa-trash</v-icon>
                                                                </v-btn>
                                                            </v-layout>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-card>
                                            </draggable>
                                        </v-card>
                                        <v-card v-else-if="element.text!='Custom Views'" class="accent pa-1 pl-3">
                                            <v-layout row>
                                                <v-flex xs9>
                                                    <v-icon v-if="element.icon" small class="cv_icon">
                                                        {{ element.icon }}
                                                    </v-icon>
                                                    {{ element.text }}
                                                </v-flex>
                                                <v-flex xs3>
                                                    <v-layout row wrap justify-end v-if="element.to">
                                                        <v-icon v-if="element.to.startsWith('/custom-view/')"
                                                                class="cv_icon"
                                                                :color="publishedCustomViewSet.has(element.to) ? 'primary' : 'error'">
                                                            fa-chart-bar
                                                        </v-icon>
                                                        <v-btn small icon class="primary cv_edit_btn"
                                                               @click="editedLink = element; linkDialog=true;">
                                                            <v-icon small>fa-pen</v-icon>
                                                        </v-btn>
                                                        <v-btn small icon class="primary cv_edit_btn"
                                                               @click="moveCustomViewToAvailable(element)">
                                                            <v-icon small>fa-arrow-right</v-icon>
                                                        </v-btn>
                                                    </v-layout>
                                                    <v-layout row wrap justify-end
                                                              v-if="element.href||element.href===''">
                                                        <v-icon class="cv_icon" color="primary"> fa-link</v-icon>
                                                        <v-btn small icon class="primary cv_edit_btn"
                                                               @click="editedLink = element; linkDialog=true;">
                                                            <v-icon small>fa-pen</v-icon>
                                                        </v-btn>
                                                        <v-btn small icon class="primary cv_edit_btn"
                                                               @click="removeItemBase(element)">
                                                            <v-icon small>fa-trash</v-icon>
                                                        </v-btn>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
                                        </v-card>
                                    </div>
                                </draggable>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs2>
                    </v-flex>
                    <v-flex xs5 style="padding:10px">
                        <v-card class="sticky-card draggable_folder">
                            <v-card-title class="primary white--text text--title">
                                {{ 'Available Views'|translate }}
                            </v-card-title>
                            <div v-for="element of genericItems">
                                <div v-if="element.text=='Custom Views'" style="padding: 0px; margin: 0px">
                                    <draggable v-model="element.children" group="people" @start="drag=true"
                                               @end="drag=false" class="draggable_space">
                                        <v-card v-for="child of element.children" class="cv_in_folder accent">
                                            <v-icon v-if="element.icon" small class="cv_icon"> {{ child.icon }}</v-icon>
                                            {{ child.text }}
                                        </v-card>
                                    </draggable>
                                </div>
                            </div>
                        </v-card>
                    </v-flex>
                </v-layout>
                <v-card-actions>
                    <v-btn v-if="closable" @click="close">{{ 'Close'|translate }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn class="primary" @click="saveMenuConfig()">{{ 'Save'|translate }}</v-btn>
                </v-card-actions>
            </v-card>

            <v-dialog v-model="dialogEditFolderName" max-width="300">
                <v-card v-if="dialogEditFolderName&&editedFolder">
                    <v-card-title class="primary white--text title">
                        {{ 'Edit Folder Name'|translate }}
                    </v-card-title>
                    <v-card-text>
                        <v-text-field :label="'Name'|translate" v-model="editedFolder.text" required></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="primary" @click="dialogEditFolderName=false">{{ 'Ok'|translate }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="linkDialog" max-width="500">
                <v-card v-if="linkDialog&&editedLink">
                    <v-card-title class="primary white--text title">
                        {{ 'Link Settings'|translate }}
                    </v-card-title>
                    <v-card-text>
                        <v-text-field :label="'Name'|translate" v-model="editedLink.text" required></v-text-field>
                        <v-text-field :label="'Link'|translate" v-model="editedLink.href"
                                      v-if="editedLink.href||editedLink.href===''" required></v-text-field>
                        <v-layout row>
                            <v-flex xs2>
                                <v-icon large style="margin: 10px"> {{ editedLink.icon }}</v-icon>
                            </v-flex>
                            <v-flex xs10>
                                <v-text-field clearable :label="'Icon'|translate" v-model="editedLink.icon"
                                              required></v-text-field>
                            </v-flex>
                        </v-layout>

                        <v-btn icon v-for="icon in iconOptions" @click="editedLink.icon=icon" class="primary">
                            <v-icon> {{ icon }}</v-icon>
                        </v-btn>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="primary" @click="linkDialog=false">{{ 'OK'|translate }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </v-flex>
    </v-layout>
</template>

<script>
import {mapGetters} from 'vuex'
import draggable from 'vuedraggable'
import {getConfig, putConfig} from '../helper'
import _ from "lodash";

export default {
    components: {
        draggable
    },
    props: {
        closable: {type: Boolean, default: false},
        forceMobileMode: {type: Boolean, default: false},
    },
    data() {
        return {
            genericItems: [],
            menuList: [],
            newFolderName: '',
            newLinkName: null,
            editedLink: null,
            editedFolder: null,
            linkDialog: false,
            editorData: false,
            dialogEditFolderName: false,
            config: [],
            dialogEditCustomView: false,
            publishedCustomViewSet: '',
            iconOptions: ['fa-notes-medical', 'fa-angle-down', 'fa-cog', 'fa-ruler-horizontal', 'fa-tools', 'fa-building', 'fa-broadcast-tower', 'fa-cog', 'fa-bell', 'fa-sliders-h', 'fa-mail-bulk', 'fa-align-justify', 'fa-download', 'fa-chart-bar', 'fa-calendar-alt', 'fa-bars', 'fa-users', 'fa-info', 'fa-caret-down', 'fa-trash', 'fa-filter', 'fa-arrow-right', 'fa-save', 'fa-tint', 'fa-edit', 'fa-plus', 'fa-image', 'fa-chalkboard', 'fa-tachometer-alt', 'fa-globe-europe', 'fa-wind', 'fa-temperature-low', 'fa-pump-soap', 'fa-clipboard-list', 'fa-bolt', 'fa-chart-pie', 'fa-th', 'fa-cube', 'fa-circle', 'fa-code', 'fa-history', 'fa-map-marker', 'fa-piggy-bank'],

        }
    },
    methods: {
        getAllViews() {
            let allItems = JSON.parse(JSON.stringify(this.menuConfig))
            if (this.mobileMode) {
                allItems = JSON.parse(JSON.stringify(this.mobileMenuConfig))
            }
            let defaultItems = []
            if (process.env.VUE_APP_MENU_CONFIG && process.env.VUE_APP_MENU_CONFIG !== "") {
                defaultItems = require('../config/menu/' + process.env.VUE_APP_MENU_CONFIG + ".js").default()
                defaultItems = JSON.parse(JSON.stringify(defaultItems))
            } else {
                defaultItems = require('../config/menu/generic.js').default()
                defaultItems = JSON.parse(JSON.stringify(defaultItems))
            }
            for (let index in defaultItems) {
                if (defaultItems[index].text === 'Setup') {
                    defaultItems.splice(index, 1);
                    break;
                }
            }
            for (let index in allItems) {
                if (allItems[index].text === 'Setup') {
                    allItems.splice(index, 1);
                    break;
                }
            }
            let me = this
            if (this.publishedCustomViews) {
                let filtered = this.publishedCustomViews.filter(x => x.facility === me.$store.state.pointsListStore.pointsList.facility_name)
                for (let userPlot of filtered) {
                    let itemTo = "/custom-view/" + userPlot.id
                    let foundOccurences = allItems.filter(x => x.to === itemTo || (x.children && x.children.filter(y => y.to === itemTo).length > 0))
                    if (foundOccurences.length > 0) {
                        continue
                    }
                    let itemEntry = {'text': userPlot.linkTitle, 'to': itemTo};
                    if (userPlot.icon) {
                        itemEntry.icon = userPlot.icon
                    }
                    let menuName = 'Custom Views'
                    let found = false;
                    for (let item of allItems) {
                        if (item.children && item.text === menuName) {
                            item.children.push(itemEntry)
                            found = true;
                            break;
                        }
                    }
                    if (!found) {
                        allItems.push({
                            icon: 'fa-angle-up',
                            'icon-alt': 'fa-angle-down',
                            text: menuName,
                            model: false,
                            children: [itemEntry]
                        });
                    }
                }
            }

            if (this.publishedCustomViews) {
                for (let index = 0; index < allItems.length;) {

                    if (allItems[index].to) {
                        let str = allItems[index].to
                        if (str.includes('/custom-views/') && !(this.publishedCustomViewSet.has(str))) {
                            allItems.splice(index, 1);
                        } else {
                            index++;
                        }
                    } else if (allItems[index].children > 0) {
                        let all_children = allItems[index].children
                        for (let i = 0; i < all_children.length;) {
                            let str = allItems[index].to
                            if (!(this.publishedCustomViewSet.has(str))) {
                                allItems.splice(index, 1);
                            } else {
                                index++;
                            }
                        }
                    } else {
                        index++
                    }
                }
            }

            if (defaultItems.length > 0) {
                for (let element of defaultItems) {
                    if (element.to) {
                        let itemTo = element.to
                        let foundOccurences = allItems.filter(x => x.to === itemTo || (x.children && x.children.filter(y => y.to === itemTo).length > 0))
                        if (foundOccurences.length > 0) {
                            continue
                        }
                        let itemEntry = element
                        let menuName = 'Custom Views'
                        let found = false;
                        for (let item of allItems) {
                            if (item.children && item.text === menuName) {
                                item.children.push(itemEntry)
                                found = true;
                                break;
                            }
                        }
                        if (!found) {
                            allItems.push({
                                icon: 'fa-angle-up',
                                'icon-alt': 'fa-angle-down',
                                text: menuName,
                                model: false,
                                children: [itemEntry]
                            });
                        }
                    } else {
                        for (let child of element.children) {
                            let itemTo = child.to
                            let foundOccurences = allItems.filter(x => x.to === itemTo || (x.children && x.children.filter(y => y.to === itemTo).length > 0))
                            if (foundOccurences.length > 0) {
                                continue
                            }
                            let itemEntry = child
                            let menuName = 'Custom Views'
                            let found = false;
                            for (let item of allItems) {
                                if (item.children && item.text === menuName) {
                                    item.children.push(itemEntry)
                                    found = true;
                                    break;
                                }
                            }
                            if (!found) {
                                allItems.push({
                                    icon: 'fa-angle-up',
                                    'icon-alt': 'fa-angle-down',
                                    text: menuName,
                                    model: false,
                                    children: [itemEntry]
                                });
                            }

                        }
                    }
                }
            }

            let custom_view_exist = false;
            for (let element of allItems) {
                if (element.text == 'Custom Views') {
                    custom_view_exist = true
                    break;
                }
            }
            if (!custom_view_exist) {
                allItems.push({
                    icon: 'fa-angle-up',
                    'icon-alt': 'fa-angle-down',
                    text: 'Custom Views',
                    model: false,
                    children: []
                });
            }

            this.genericItems = allItems
            let formatItem = this.filterCustomerView(allItems)
            this.menuList = JSON.parse(JSON.stringify(formatItem))
        },
        filterCustomerView(menuList) {
            let allItems = []
            for (let element of menuList) {
                if (element.text != 'Custom Views') {
                    allItems.push(element)
                }
            }
            return allItems
        },
        checkNestedFolder() {
            for (let element of this.menuList) {
                if (element.children) {
                    for (let child of element.children)
                        if (child.children && !child.to) {
                            return false
                        }
                }
            }
            return true
        },
        async saveMenuConfig() {
            let configName = this.mobileMode ? "mobileMenuConfig" : "menuConfig";
            if (!this.checkNestedFolder()) {
                alert(this.$options.filters.translate("Folder cannot be nested!"));
                return;
            }
            let payload = {
                'config_id': null,
                'config_name': configName,
                'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                'config': JSON.stringify(this.menuList),
            }
            let firstSetting = true
            if (firstSetting) {
                let df = await getConfig({
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                })
                this.config = df['result']
            }
            for (let cfRec of this.config) {
                if (cfRec.config_name === configName) {
                    payload.config_id = cfRec.config_id
                    firstSetting = false
                    break
                }
            }
            await putConfig(payload)
            await this.$store.dispatch('refreshConfig', {facility_name: this.$store.state.pointsListStore.pointsList.facility_name})
            await this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Changes saved')})
        },
        addFolder() {
            for (let element of this.menuList) {
                if (element.children && this.newFolderName === element.text) {
                    alert(this.$options.filters.translate("Folder name must be unique."))
                    return;
                }
            }
            let newFolder = {
                icon: 'fa-angle-up',
                'icon-alt': 'fa-angle-down',
                text: this.newFolderName,
                model: false,
                children: []
            }
            this.menuList.push(newFolder)
            this.newFolderName = ''

        },
        addLink() {
            for (let element of this.menuList) {
                if (element.children && this.newLinkName === element.text) {
                    alert(this.$options.filters.translate("Name must be unique."))
                    return;
                }
            }
            let newLink = {
                text: this.newLinkName,
                to: null,
                icon: null,
                href: "/"
            }
            this.menuList.push(newLink)
            this.newLinkName = ''

        },
        removeFolder(deleteItem) {
            const index = this.menuList.indexOf(deleteItem);
            this.menuList.splice(index, 1);
        },
        removeItemBase(item) {
            const index = this.menuList.indexOf(item);
            this.menuList.splice(index, 1);
        },
        removeItemCH(item, parent) {
            const index = parent.children.indexOf(item);
            parent.children.splice(index, 1);
        },
        published_custom_view_set() {
            const custom_view_set = new Set()
            let me = this
            let filtered = this.publishedCustomViews.filter(x => x.facility === me.$store.state.pointsListStore.pointsList.facility_name)
            for (let userPlot of filtered) {
                let itemTo = "/custom-view/" + userPlot.id
                custom_view_set.add(itemTo);
            }
            this.publishedCustomViewSet = custom_view_set
        },
        moveCustomViewToAvailable(moveElement) {
            for (let element of this.genericItems) {
                if (element.text === 'Custom Views') {
                    element.children.push(moveElement)
                    break;
                }
            }
            for (let [index, item] of this.menuList.entries()) {
                if (item.to) {
                    if (moveElement.to === item.to) {
                        this.menuList.splice(index, 1);
                        return;
                    }
                } else if (item.children.length > 0) {
                    for (let [i, child] of item.children.entries()) {
                        if (moveElement.to === child.to) {
                            item.children.splice(i, 1);
                            return;
                        }
                    }
                }
            }
        },
        close() {
            this.$emit('close')
        }

    },
    computed: {
        ...mapGetters([
            'publishedCustomViews', 'menuConfig', 'mobileMenuConfig'
        ]),
        mobileMode() {
            if (this.forceMobileMode) {
                return true
            } else {
                return _.get(this.$route.query, 'mobile-mode', false)
            }
        }
    },
    async mounted() {
        this.published_custom_view_set()
        this.getAllViews()
        let df = getConfig({
            facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
        })
        this.config = df['result']
        this.loading = false
    }
}
</script>

<style scoped>

.cv_edit_btn {
    margin: 0px 0px 0px 5px;
}

.draggable_card {
    margin: 3px;
}

.menu_panel {
    margin: 3px;
}

.draggable_folder {
    padding: 0px 0px 5px 0px;
}

.draggable_space {
    min-height: 50px;
}

.cv_icon {
    margin: 0px 10px 0px 0px;
    padding: 0px
}

.cv_in_folder {
    text-indent: 5px;
    margin: 5px 15px 5px 15px;
    padding: 5px;
}

.sticky-card {
    position: sticky;
    top: 100px;
    z-index: 1;
}

.after-sticky {
    margin-top: 90px;
}

</style>